/**
 * Request utility wrapper
 *
 * 对接 tRPC 后端（trpc.samples.deeptutor.Admin），响应结构 {Code, Message, Data}。
 */
import { request as umiRequest } from '@umijs/max';

// Base response structure from backend
export interface Result<T = any> {
    Code: number;
    Message: string;
    Data: T;
}

export interface RequestOptions {
    headers?: Record<string, string>;
    params?: Record<string, any>;
    [key: string]: any;
}

const API_PREFIX = process.env.UMI_APP_API_PREFIX || '/api';

const getFullUrl = (url: string): string => {
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(API_PREFIX)) {
        return url;
    }
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    return `${API_PREFIX}${normalizedUrl}`;
};

export const http = {
    get<T = any>(url: string, options?: RequestOptions): Promise<Result<T>> {
        return umiRequest<Result<T>>(getFullUrl(url), {
            method: 'GET',
            ...options,
        });
    },
    post<T = any>(url: string, data?: any, options?: RequestOptions): Promise<Result<T>> {
        return umiRequest<Result<T>>(getFullUrl(url), {
            method: 'POST',
            data,
            ...options,
        });
    },
    put<T = any>(url: string, data?: any, options?: RequestOptions): Promise<Result<T>> {
        return umiRequest<Result<T>>(getFullUrl(url), {
            method: 'PUT',
            data,
            ...options,
        });
    },
    delete<T = any>(url: string, options?: RequestOptions): Promise<Result<T>> {
        return umiRequest<Result<T>>(getFullUrl(url), {
            method: 'DELETE',
            ...options,
        });
    },
    patch<T = any>(url: string, data?: any, options?: RequestOptions): Promise<Result<T>> {
        return umiRequest<Result<T>>(getFullUrl(url), {
            method: 'PATCH',
            data,
            ...options,
        });
    },
};

export { umiRequest as request };
